export default __webpack_public_path__ + "static/media/tree21.f21a2269.png";